import React from "react";
import { Typography, Space } from "antd";
import { CompassOutlined } from "@ant-design/icons";
import { GoogleMap, useJsApiLoader, Marker } from "@react-google-maps/api";
import CustomCard from "../../blocks/Card/Card";

const { Text, Title } = Typography;

const mapContainerStyle = {
  width: "100%",
  height: "300px",
};

const center = {
  lat: 34.0645065, // Latitude for 23311 W Paloma Blanca Dr, Malibu, CA 90265
  lng: -118.6495132, // Longitude for 23311 W Paloma Blanca Dr, Malibu, CA 90265
};
const libraries = ["places", "visualization"];

const PropertyLocation = () => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyBDqhAD8puCskqZSn2xZ1FdIvQl3rwaR-Y",
    libraries,
  });

  return (
    <CustomCard
      title={<Title level={4}>Property Location</Title>}
      className="card-height"
      cover={
        isLoaded ? (
          <GoogleMap
            mapContainerStyle={mapContainerStyle}
            center={center}
            zoom={15}
          >
            <Marker position={center} />
          </GoogleMap>
        ) : (
          <div
            style={{
              height: "300px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            Loading map...
          </div>
        )
      }
    >
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        <div>
          <Title level={4}>Address</Title>
          <Text>23311 W Paloma Blanca Dr, Malibu, CA 90265</Text>
        </div>
        <div>
          <Title level={4}>About the Area</Title>
          <Text>
            <CompassOutlined /> Malibu is renowned for its:
          </Text>
          <ul>
            <li>Beautiful beaches stretching along the Pacific Coast</li>
            <li>High-end real estate market</li>
            <li>Celebrity residents and luxury lifestyle</li>
            <li>Scenic coastal views and outdoor recreational opportunities</li>
          </ul>
        </div>
        <Text type="secondary">
          Note: This prime location contributes significantly to the property's
          value and desirability.
        </Text>
      </Space>
    </CustomCard>
  );
};

export default PropertyLocation;
